import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { ElementWidthClassDirective } from '@app/shared/directives/element-width-class-directive';
import { POPUP_MINIMIZED_WIDTH_SIZE } from '@app/main/main-content/floating-popup-manager/configs/floating-popup.config';
import { FloatingPopupLineChartWrapperComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-line-chart-wrapper/floating-popup-line-chart-wrapper.component';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FpCorrelationSpectrumChartService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum-chart.service';
import { FpCorrelationSpectrumStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum/fp-correlation-spectrum.store';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-correlation-spectrum-minimized',
  standalone: true,
  imports: [ElementWidthClassDirective, FloatingPopupLineChartWrapperComponent, FloatingPopupBaseErrorMessageComponent],
  templateUrl: './fp-correlation-spectrum-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full',
  },
})
export class FpCorrelationSpectrumMinimizedComponent {
  public readonly currentTabStore = inject(FpCorrelationSpectrumStore);
  protected readonly translateService = inject(TranslateService);
  protected readonly chartService = inject(FpCorrelationSpectrumChartService);

  public popup = input<IFloatingPopupInstance>();

  public readonly POPUP_MINIMIZED_WIDTH_SIZE = POPUP_MINIMIZED_WIDTH_SIZE;

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  private readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isChartDataExist = computed(() => !!this.data()?.length);

  public readonly correlation = computed(() => this.popupMainData()?.correlation);

  public combinedChartData = computed(() => {
    const data = this.data() || [];

    const chartData = this.chartService.getMinimizedDataForChart(data);
    const chartOptions = this.chartService.generateMinimizedOptions(data);

    return { chartData, chartOptions };
  });
}
